<template>
  <div class="item-btn" :class="model.isCollect ? 'btn-red' : 'btn-default'" @click="$com.addCollect(model, type)">
    {{ model.isCollect ? '移除书架' : '加入书架' }}
  </div>
</template>

<script>
export default {
  props: {
    model: { type: Object, default: {} },
    type: { type: String, default: "book" },
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/common/ButtonCollectView.vue